import React, { useState } from "react";
import ModalComponent from "components/UI/MaterialUIComponents/ModalComponent";
import Skeleton from "@material-ui/lab/Skeleton";
import "./CardCatalogue.scss";
import Icon from "../../../Icons/SvgIcons";
import { eliminar } from "services/crudFirebase";
import StepperAddOrEditForm from "../StepperForm/StepperAddOrEditForm";
import CarouselElement from "../CarouselElement/CarouselElement";
import LazyLoad from "react-lazyload";
import skeleton from "images/skeletonCatalogue.png";
import Buttons from "../Button/Buttons";
import { v4 as uuidv4 } from "uuid";

const CardCatalogue = ({
	datosObtenidos,
	setDatosObtenidos,
	item,
	loading,
	edit,
}) => {
	const [stateModal, setStateModal] = useState(true);
	const handleCloseModal = () => setStateModal(false);
	const [key] = useState(uuidv4());

	const onDeleteElement = () => {
		eliminar(item.id, "CatalogoFlexores");
		const updateData = [...datosObtenidos];
		let returnElements = [];
		updateData.forEach((i) => {
			if (item.id !== i.id) {
				returnElements = [...returnElements, i];
			}
		});
		setDatosObtenidos(returnElements);
		handleCloseModal();
	};

	return (
		<>
			<div
				className={!edit ? "catalogue__card" : "catalogue__card--edit"}
				key={key}
			>
				{edit && (
					<>
						<div className="groupButtons--edit">
							<ModalComponent
								stateModal={stateModal}
								scrollable={true}
								setStateModal={setStateModal}
								classNameBtnOpenModal="catalogue__card__btn--edit"
								slotOpenModal={
									<span title="Editar Producto">
										<Icon svg="edit" classes="svgIcon--edit" title="edit" />
									</span>
								}
							>
								<StepperAddOrEditForm
									setItems={setDatosObtenidos}
									items={datosObtenidos}
									item={item}
									type="edit"
									handleClose={handleCloseModal}
									steps={[
										"Marca",
										"Modelo",
										"Tipo",
										"Numeración",
										"Imagenes",
										"Precio",
									]}
								/>
							</ModalComponent>
							<ModalComponent
								stateModal={stateModal}
								setStateModal={setStateModal}
								classNameBtnOpenModal="catalogue__card__btn--delete"
								slotOpenModal={
									<span title="Eliminar Producto">
										<Icon
											svg="delete"
											classes="svgIcon--delete"
											title="delete"
										/>
									</span>
								}
							>
								<div className="modalConfirmDelete">
									<span className="modalConfirmDelete__Span">
										¿Está seguro que desea eliminar este producto de forma
										permanete?
									</span>
									<div className="modalConfirmDelete__groupBtn">
										<Buttons className="btnPrimary" onClick={onDeleteElement}>
											Eliminar
										</Buttons>
										<Buttons
											className="groupBtn__btn--cancel btnSecondary"
											onClick={handleCloseModal}
										>
											Cancelar
										</Buttons>
									</div>
								</div>
							</ModalComponent>
						</div>
					</>
				)}
				<div className="catalogue__image">
					{loading ? (
						<Skeleton className="CarouselElement--skeleton" />
					) : (
						<ModalComponent
							componentInside="CarouselElement"
							imageButton={item.Img}
							typeButton="image"
							stateModal={stateModal}
							setStateModal={setStateModal}
							slotOpenModal={
								<LazyLoad>
									<img className="skeletonImg" src={skeleton} alt="" />
									<img alt="" src={item.Img} />
								</LazyLoad>
							}
						>
							{<CarouselElement images={item.Img} />}
						</ModalComponent>
					)}
				</div>
				<div className="card__info">
					{loading ? (
						<>
							<Skeleton className="info__title--skeleton" />
							<Skeleton className="info__brandAndModel--skeleton" />
						</>
					) : (
						<>
							<h2 className="info__title">{item.Tipo}</h2>
							{item.ModelosCompatibles.map((i) => {
								return (
									<>
										<span className="info__brandAndModel">
											{`${i.Brand} ${i.Model}`}
										</span>
										<span className="info__num">{i.Num}</span>
									</>
								);
							})}
						</>
					)}
				</div>
				<div className="card__infoPrice">
					{loading ? (
						<Skeleton className="infoPrice__price--skeleton" />
					) : (
						<>
							<span className="infoPrice__price">
								<span className="infoPrice__price">$ {item.Precio}</span>
								<span className="infoPrice__note">* PRECIO DE MAYOREO</span>
							</span>
						</>
					)}
				</div>
			</div>
		</>
	);
};

export default CardCatalogue;
